import Vue from 'vue'
import {http} from '../../axios'

const mutationsSubscribeNames = [
  'addFilesToUpload',
  'deleteFileToUpload',
  'deleteFileUploaded',
]

function getInitState() {
  return  {
    muted: false,
    sizeLimitMB: 100,
    pendingUpload: false,
    pendingLoad: false,
    filesToUpload: [],
    filesUploaded: []
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames,
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setPendingUpload(state, value) {
      state.pendingUpload = value
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    addFilesToUpload(state, files) {
      for (const file of files) {
        state.filesToUpload.push(file)
      }
    },
    setFilesToUpload(state, files) {
      state.filesToUpload = files || []
    },
    setFilesUploaded(state, files) {
      state.filesUploaded = files ||  []
    },
    deleteFileToUpload(state, index) {
      state.filesToUpload.splice(index, 1)
    },
    deleteFileUploaded(state, index) {
      state.filesUploaded.splice(index, 1)
    },
    setFileDeletePending(state, index) {
      Vue.set(state.filesUploaded[index], 'deletePending', true)
    }
  },
  actions: {
    upload({state, commit}, vacancyId) {
      if (!state.muted || !vacancyId || !state.filesToUpload.length) return Promise.resolve('ok')
      const sendData = new FormData()

      for (const file of state.filesToUpload) {
        sendData.append('files[]', file)
      }

      commit('setPendingUpload', true)
      return http.post(`/api/vacancy/${vacancyId}/files`, sendData).then(({data}) => {
        commit('setFilesToUpload', [])
        commit('setFilesUploaded', [...state.filesUploaded, ...data.data])
      }).finally(() => {
        commit('setPendingUpload', false)
      })
    },
    deleteFileUploaded({commit}, {vacancyId, index, id}) {
      commit('setFileDeletePending', index)

      http.delete(`/api/vacancy/${vacancyId}/file/${id}`).then(() => {
        commit('deleteFileUploaded', index)
      })
    },
    setVacancyValues({commit}, vacancy) {
      commit('setFilesUploaded', vacancy.additional_files)
    }
  }
}
